// https://bscscan.com/address/0x9d33ee6543C9b2C8c183b8fb58fB089266cffA19
export const CROSS_CHAIN_CONTROLLER = '0x9d33ee6543C9b2C8c183b8fb58fB089266cffA19';

// https://bscscan.com/address/0xcabb46FfB38c93348Df16558DF156e9f68F9F7F1
export const CL_EMERGENCY_ORACLE = '0xcabb46FfB38c93348Df16558DF156e9f68F9F7F1';

// IPayloadsControllerCore https://bscscan.com/address/0xE5EF2Dd06755A97e975f7E282f828224F2C3e627
export const PAYLOADS_CONTROLLER = '0xE5EF2Dd06755A97e975f7E282f828224F2C3e627';

// https://bscscan.com/address/0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A
export const PC_DATA_HELPER = '0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A';

// https://bscscan.com/address/0xe4FB5e3F506BE0095f38004f993D16fdA8224383
export const GRANULAR_GUARDIAN = '0xe4FB5e3F506BE0095f38004f993D16fdA8224383';

// https://bscscan.com/address/0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b
export const GOVERNANCE_GUARDIAN = '0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b';

// https://bscscan.com/address/0x9390B1735def18560c509E2d0bc090E9d6BA257a
export const EXECUTOR_LVL_1 = '0x9390B1735def18560c509E2d0bc090E9d6BA257a';

export const CHAIN_ID = 56;
